<template>
  <div class="labeled-vehicle-number-input">
    <InputLabel
      :input-id="inputId"
      :label="label"
      :required-icon="requiredIcon"
      :tooltip="tooltip"
    />
    <VehicleLicensePlateInput
      ref="vehicleLicensePlateInput"
      :id="inputId"
      :value="value"
      :placeholder="placeholder"
      :valid-vehicle-license-plate-groups="validVehicleLicensePlateGroups"
      :is-disabled="isDisabled"
      :limit="limit"
      :empty-text="emptyText"
      :error-messages="errorMessages"
      v-on="$listeners"
      v-bind="$attrs"
    >
      <slot />
    </VehicleLicensePlateInput>
  </div>
</template>

<script>
import { default as VehicleLicensePlateInput } from '../vehicle-license-plate-input';
import { RandomId } from '@/shared/lib/random';
import { InputLabel } from '@/shared/ui/form';

const { generateRandomId } = RandomId();

export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number, Object],
      default: null,
    },
    placeholder: {
      type: String,
      default: ''
    },
    requiredIcon: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Object,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    validVehicleLicensePlateGroups: {
      type: Array,
      default: () => [],
    },
    emptyText: {
      type: String,
      default: 'No options available',
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    limit: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      inputId: `vehicle-number-${this.generateRandomId()}`,
    };
  },
  components: { InputLabel, VehicleLicensePlateInput },
  computed: {
    getVehicleLicensePlateInput() {
      return this.$refs.vehicleLicensePlateInput;
    }
  },
  methods: {
    generateRandomId,
  },
};
</script>
